import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { useEffect } from "react";
import Page from "components/layout/Page";
import { AdminRoute, PrivateRoute, PublicRoute } from "@components/routes";
import Login from "@pages/auth/Login";
import Register from "@pages/auth/Register";
import Terms from "@pages/auth/Terms";
import UserDashboard from "@pages/user/UserDashboard";
import Logout from "@pages/auth/Logout";
import AccountingDashboard from "@pages/user/AccountingDashboard";
import Profile from "@pages/user/Profile";
import LinksIndex from "@pages/user/Links/Index";
import EmailTemplates from "@pages/user/EmailTemplates";
import EmailTemplate from "@pages/user/EmailTemplate";
import SalesmanIndex from "@pages/user/Salesmen/Index";
import SalesmanAddEdit from "@pages/user/Salesmen/AddEdit";
import CreditOperatorsIndex from "@pages/user/CreditOperators/Index";
import CreditOperatorAddEdit from "@pages/user/CreditOperators/AddEdit";
import ZonesIndex from "@pages/user/Zones/Index";
import ZoneAddEdit from "@pages/user/Zones/AddEdit";
import BankAccountAddEdit from "@pages/user/BankAccounts/AddEdit";
import BankAccountsIndex from "@pages/user/BankAccounts/Index";
import CurrencyAddEdit from "@pages/user/Currencies/AddEdit";
import CurrenciesIndex from "@pages/user/Currencies/Index";
import ActivityCodeAddEdit from "@pages/user/ActivityCodes/AddEdit";
import ActivityCodesIndex from "@pages/user/ActivityCodes/Index";
import CustomFields from "@pages/user/CustomFields";
import CustomField from "@pages/user/CustomField";
import PriceAddEdit from "@pages/user/PriceManagement/AddEdit";
import PriceManagement from "@pages/user/PriceManagement/Index";
import ApiManagement from "@pages/user/ApiManagement/Index";
import ProductIndex from "@pages/user/Products/Index";
import ProductAddEdit from "@pages/user/Products/AddEdit";
import CategoryIndex from "@pages/user/Categories/Index";
import CategoryAddEdit from "@pages/user/Categories/AddEdit";
import ClientAddEdit from "@pages/user/Clients/AddEdit";
import ClientIndex from "@pages/user/Clients/Index";
import ClientImport from "@pages/user/Clients/Import";
import ShippingProviderIndex from "@pages/user/ShippingProviders/Index";
import ShippingProviderAddEdit from "@pages/user/ShippingProviders/AddEdit";
import ProviderImport from "@pages/user/Providers/Import";
import ClientsDashboard from "@pages/user/ClientsDashboard";
import ProviderAddEdit from "@pages/user/Providers/AddEdit";
import ProviderIndex from "@pages/user/Providers/Index";
import ProvidersDashboard from "@pages/user/ProvidersDashboard";
import ProviderInvoiceCategoryAddEdit from "@pages/user/ProviderInvoiceCategories/AddEdit";
import ProviderInvoiceCategoryIndex from "@pages/user/ProviderInvoiceCategories/Index";
import ExpenseCategoryIndex from "@pages/user/ExpenseCategories/Index";
import ExpenseCategoryAddEdit from "@pages/user/ExpenseCategories/AddEdit";
import RecibeIndex from "@pages/user/Recibes/Index";
import RecibeAddEdit from "@pages/user/Recibes/AddEdit";
import ProviderInvoiceIndex from "@pages/user/ProviderInvoices/Index";
import ProviderInvoiceAddEdit from "@pages/user/ProviderInvoices/AddEdit";
import ExpenseIndex from "@pages/user/Expenses/Index";
import ExpenseAddEdit from "@pages/user/Expenses/AddEdit";
import ProviderNoteIndex from "@pages/user/ProviderNotes/Index";
import ProviderNoteAddEdit from "@pages/user/ProviderNotes/AddEdit";
import ProviderInvoicePaymentIndex from "@pages/user/ProviderInvoicePayments/Index";
import ProviderInvoicePaymentAddEdit from "@pages/user/ProviderInvoicePayments/AddEdit";
import InvoiceIndex from "@pages/user/Invoices/Index";
import InvoiceAdd from "@pages/user/Invoices/Add";
import AppLayout from "./template/AppLayout/Index";
import PrintLayout from "./template/PrintLayout/Index";
import InvoicePrint from "@pages/user/Invoices/Print";
import InvoiceShippingGuide from "@pages/user/Invoices/ShippingGuide";
import InvoiceTemplateIndex from "@pages/user/InvoiceTemplates/Index";
import InvoiceTemplateAddEdit from "@pages/user/InvoiceTemplates/AddEdit";
import QuoteIndex from "@pages/user/Quotes/Index";
import QuoteAddEdit from "@pages/user/Quotes/AddEdit";
import QuotePrint from "@pages/user/Quotes/Print";
import SettlementIndex from "@pages/user/Settlements/Index";
import SettlementAdd from "@pages/user/Settlements/Add";
import SettlementPrint from "@pages/user/Settlements/Print";
import InvoiceCancel from "@pages/user/Invoices/Cancel";
import InvoiceImport from "@pages/user/Invoices/Import";
import CreditnoteIndex from "@pages/user/Creditnotes/Index";
import CreditnoteImport from "@pages/user/Creditnotes/Import";
import DebitnoteImport from "@pages/user/Debitnotes/Import";
import CreditnoteAdd from "@pages/user/Creditnotes/Add";
import CreditnoteInvoiceSelect from "@pages/user/Creditnotes/InvoiceSelect";
import CreditnotePrint from "@pages/user/Creditnotes/Print";
import DebitnoteIndex from "@pages/user/Debitnotes/Index";
import DebitnoteInvoiceSelect from "@pages/user/Debitnotes/InvoiceSelect";
import DebitnoteAdd from "@pages/user/Debitnotes/Add";
import DebitnotePrint from "@pages/user/Debitnotes/Print";
import ClientStatusIndex from "@pages/user/Clients/Status";
import CreditnoteListByInvoiceId from "@pages/user/Creditnotes/ListByInvoiceId";
import DebitnoteListByInvoiceId from "@pages/user/Debitnotes/ListByInvoiceId";
import ClientPrintStatus from "@pages/user/Clients/PrintStatus";
import PayInvoicesIndex from "@pages/user/Clients/PayInvoices";
import ClientCreditsIndex from "@pages/user/Clients/Credits";
import DocumentInterestListByInvoiceId from "@pages/user/DocumentInterests/ListByInvoiceId";
import InvoicePaymentIndex from "@pages/user/Invoices/Payments";
import SettlementPaymentIndex from "@pages/user/Settlements/Payments";
import RecibePrint from "@pages/user/Recibes/Print";
import ValidateEInvoice from "@pages/user/ProviderInvoices/ValidateEInvoice";
import AtvMessageIndex from "@pages/user/AtvMessages/Index";
import AtvMessageListByInvoiceId from "@pages/user/AtvMessages/ListByInvoiceId";
import ValidateENote from "@pages/user/ProviderNotes/ValidateENote";
import AtvMessageListByInvoiceNoteId from "@pages/user/AtvMessages/ListByInvoiceNoteId";
import ValidateExpenseEInvoice from "@pages/user/Expenses/ValidateEInvoice";
import AtvMessageListByExpenseId from "@pages/user/AtvMessages/ListByExpenseId";
import ExpenseNoteIndex from "@pages/user/ExpenseNotes/Index";
import ExpenseNoteAddEdit from "@pages/user/ExpenseNotes/AddEdit";
import ValidateExpenseENote from "@pages/user/ExpenseNotes/ValidateENote";
import ProviderStatusIndex from "@pages/user/Providers/Status";
import ProviderPrintStatus from "@pages/user/Providers/PrintStatus";
import PayProviderInvoicesIndex from "@pages/user/Providers/PayInvoices";
import ProviderRecibeIndex from "@pages/user/ProviderRecibes/Index";
import BuyByMonthReport from "@pages/user/Reports/BuyByMonth";
import BuyByPeriodReportPrint from "@pages/user/Reports/BuyByMonth/Print";
import BuyByYearReport from "@pages/user/Reports/BuyByYear";
import ExpenseByMonthReport from "@pages/user/Reports/ExpenseByMonth";
import ExpenseByPeriodReportPrint from "@pages/user/Reports/ExpenseByMonth/Print";
import SalesByClientReportPrint from "@pages/user/Reports/SalesByClient/Print";
import ExpenseByYearReport from "@pages/user/Reports/ExpenseByYear";
import SellByMonthReport from "@pages/user/Reports/SellByMonth";
import SellByPeriodReportPrint from "@pages/user/Reports/SellByMonth/Print";
import ClientSettlementsReport from "@pages/user/Reports/ClientSettlements";
import EDocumentsReport from "@pages/user/Reports/EDocuments";
import EDocumentsReportExcel from "@pages/user/Reports/EDocuments/Excel";
import ClientSettlementsReportPrint from "@pages/user/Reports/ClientSettlements/Print";
import SellByYearReport from "@pages/user/Reports/SellByYear";
import ProductlogIndex from "@pages/user/Productlogs/Index";
import ProductCostLogIndex from "@pages/user/ProductCostlogs/Index";
import BuyInvoiceIndex from "@pages/user/BuyInvoices/Index";
import BuyInvoiceAdd from "@pages/user/BuyInvoices/Add";
import BuyInvoicePrint from "@pages/user/BuyInvoices/Print";
import BuyInvoicePaymentIndex from "@pages/user/BuyInvoicePayments/Index";
import BuyInvoicePaymentAddEdit from "@pages/user/BuyInvoicePayments/AddEdit";
import ProviderInvoiceAddWithInventory from "@pages/user/ProviderInvoices/AddWithInventory";
import ExcelLayout from "./template/ExcelLayout/Index";
import InvoicePaymentPrint from "@pages/user/Invoices/Payments/Print";
import ProductGenerateBarcode from "@pages/user/Products/GenerateBarcodes";
import InventoryManagement from "@pages/user/Products/InventoryManagement";
import CabysAudit from "@pages/user/Products/CabysAudit";
import ProductImport from "@pages/user/Products/Import";
import RoleIndex from "@pages/user/Roles/Index";
import AddEditRole from "@pages/user/Roles/AddEdit";
import UserIndex from "@pages/user/Users/Index";
import AddEditUser from "@pages/user/Users/AddEdit";
import InventoryDashboard from "@pages/user/InventoryDashboard";
import InventoryReportPrint from "@pages/user/Reports/Inventory/Print";
import InventoryReportExcel from "@pages/user/Reports/Inventory/Excel";
import ListPriceReportPrint from "@pages/user/Reports/Product/Print";
import SalesByProductReport from "@pages/user/Reports/SalesByProduct";
import SalesByClientReport from "@pages/user/Reports/SalesByClient";
import ProductsByCategoryReport from "@pages/user/Reports/ProductsByCategory";
import ProductsByCategoryReportPrint from "@pages/user/Reports/ProductsByCategory/Print";
import TenantIndex from "@pages/user/Tenants/Index";
import TenantAddEdit from "@pages/user/Tenants/AddEdit";
import TenantUsersIndex from "@pages/user/Tenants/Users/Index";
import ProviderOrderAddEdit from "@pages/user/ProviderOrder/AddEdit";
import ProviderOrderIndex from "@pages/user/ProviderOrder/Index";
import ProviderOrderPrint from "@pages/user/ProviderOrder/Print";
import SuscriptionTypeIndex from "@pages/user/SuscriptionTypes/Index";
import SuscriptionTypeAddEdit from "@pages/user/SuscriptionTypes/AddEdit";
import TenantManage from "@pages/user/Tenants/Manage";
import SearchByReferenceReport from "@pages/user/Reports/SearchByReference";
import ReceivedInvoiceIndex from "@pages/user/ReceivedInvoices/Index";
import ViewReceivedInvoice from "@pages/user/ReceivedInvoices/ViewEmail";
import ProviderRecibeView from "@pages/user/ProviderRecibes/View";
import ProviderRecibeRepairIndex from "@pages/user/ProviderRecibes/Repair";

const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {

    }, [location]);

    return null
};

const SITE_NAME = "Easypos"

export const AppRoutes = () => {
    return (
            <Routes>
                <Route element={<AppLayout />}>
                    <Route path="/" element={
                        <Page title={`${SITE_NAME} | Homepage`}>
                            <Login />
                        </Page>
                    } />
                    {/* <Route path="/dashboard" element={
                        <Page title="Easypos | Dashboard">
                            <DashboardRoute />
                        </Page>} /> */}
                    <Route path="/admin" element={<AdminRoute />} >
                        <Route path="suscriptions" element={
                            <Page title="Easypos | Suscriptiones"> <Outlet /> </Page>}>
                            <Route index element={
                                <TenantIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Suscripcion">
                                    <TenantAddEdit />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Easypos | Editar Suscripcion">
                                    <TenantAddEdit />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Suscripcion">
                                    <TenantAddEdit copyData />
                                </Page>} />
                            <Route path=":id/users" element={
                                <Page title="Easypos | Usuarios de Suscripcion">
                                    <TenantUsersIndex />
                                </Page>} />
                        </Route>
                        <Route path="suscription-types" element={
                            <Page title="Easypos | Tipos de Suscriptiones"> <Outlet /> </Page>}>
                            <Route index element={
                                <SuscriptionTypeIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Tipo Suscripcion">
                                    <SuscriptionTypeAddEdit />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Easypos | Editar TipoSuscripcion">
                                    <SuscriptionTypeAddEdit />
                                </Page>} />
                            <Route path="copy/:id" element={
                                <Page title="Easypos | copiar TipoSuscripcion">
                                    <SuscriptionTypeAddEdit copyData />
                                </Page>} />
                        </Route>

                    </Route>
                    <Route path="/auth" element={<PublicRoute />} >
                        <Route path="login" element={
                            <Page title="Easypos | Inicio de sesion">
                                <Login />
                            </Page>} />
                        <Route path="logout" element={
                            <Page title="Easypos | Cerrar de sesion">
                                <Logout />
                            </Page>} />
                        <Route path="register" element={
                            <Page title="Easypos | Crear cuenta">
                                <Register />
                            </Page>} />
                        <Route path="terms" element={
                            <Page title="Easypos | Términos de uso">
                                <Terms />
                            </Page>} />
                        {/* <Route path="password-forgot" element={
                            <Page title="Easypos | Reinicio Contraseña">
                                <PasswordReset />
                            </Page>} />
                        <Route path="register" element={
                            <Page title="Easypos | Registro de usuario">
                                <Register />
                            </Page>} />
                        <Route path="validate-account" element={
                            <Page title="Easypos | Validacion de Cuenta">
                                <ValidateAccount />
                            </Page>} />
                        <Route path="account-validated" element={
                            <Page title="Easypos | Cuenta Validada">
                                <AccountValidated />
                            </Page>} /> */}
                    </Route>
                    <Route path="/user" element={<PrivateRoute />} >
                        <Route path="economy-activity/:id?" element={
                            <Page title="Easypos | Modificar Actividad Economica">
                                <ActivityCodeAddEdit />
                            </Page>} />
                        <Route path="economy-activities" element={
                            <Page title="Easypos | Actividades Economicas">
                                <ActivityCodesIndex />
                            </Page>} />
                        <Route path="bank-account/:id?" element={
                            <Page title="Easypos | Modificar Cuenta Bancaria">
                                <BankAccountAddEdit />
                            </Page>} />
                        <Route path="bank-accounts" element={
                            <Page title="Easypos | Cuentas Bancarias">
                                <BankAccountsIndex />
                            </Page>} />
                        <Route path="category/:id?" element={
                            <Page title="Easypos | Actualizar Categoria">
                                <CategoryAddEdit />
                            </Page>} />
                        <Route path="categories" element={
                            <Page title="Easypos | Categories">
                                <CategoryIndex />
                            </Page>} />
                        <Route path="client/:id?" element={
                            <Page title="Easypos | Actualizar Cliente">
                                <ClientAddEdit />
                            </Page>} />
                        <Route path="shipping-providers" element={
                            <Page title="Easypos | Proveedores de Envio">
                                <ShippingProviderIndex />
                            </Page>} />
                        <Route path="shipping-provider/:id?" element={
                            <Page title="Easypos | Actualizar Proveedor de Envio">
                                <ShippingProviderAddEdit />
                            </Page>} />
                        <Route path="acl" element={
                            <Page title="Easypos | Control de Acceso"> <Outlet /> </Page>}>
                            <Route index element={
                                <RoleIndex />
                            } />
                            <Route path="users" element={
                                <Page title="Easypos | Lista de Usuarios">
                                    <UserIndex />
                                </Page>} />
                            <Route path="user/:userId?" element={
                                <Page title="Easypos | Administrar usuario">
                                    <AddEditUser />
                                </Page>} />
                            <Route path="role/:roleId?" element={
                                <Page title="Easypos | Administrar de Usuario">
                                    <AddEditRole />
                                </Page>} />
                        </Route>
                        <Route path="atv-messages" element={
                            <Page title="Easypos | Mensajes ATV"> <Outlet /> </Page>}>
                            <Route index element={
                                <AtvMessageIndex />
                            } />
                            <Route path="listByInvoice/:invoiceId" element={
                                <Page title="Easypos | Mensajes Atv de Factura">
                                    <AtvMessageListByInvoiceId />
                                </Page>} />
                            <Route path="listByInvoiceNote/:invoiceNoteId" element={
                                <Page title="Easypos | Mensajes Atv de Factura">
                                    <AtvMessageListByInvoiceNoteId />
                                </Page>} />
                            <Route path="listByExpense/:expenseId" element={
                                <Page title="Easypos | Mensajes Atv de Factura">
                                    <AtvMessageListByExpenseId />
                                </Page>} />
                        </Route>
                        <Route path="buyInvoices" element={
                            <Page title="Easypos | Factura de Compra"> <Outlet /> </Page>}>
                            <Route index element={
                                <BuyInvoiceIndex buyInvoiceType="Buy" />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Factura Electronica de Compra">
                                    <BuyInvoiceAdd buyInvoiceType="Buy" />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Factura Electronica de Compras">
                                    <BuyInvoiceAdd copyData buyInvoiceType="Buy" />
                                </Page>} />
                            <Route path="payments/add/:buyInvoiceId" element={
                                <Page title="Easypos | Agregar Abono de Factura Electronica Compra">
                                    <BuyInvoicePaymentAddEdit />
                                </Page>} />
                            <Route path="payments/edit/:id/:buyInvoiceId" element={
                                <Page title="Easypos | Editar Abono de Factura de Electronica Compra">
                                    <BuyInvoicePaymentAddEdit />
                                </Page>} />
                            <Route path="payments/:id?" element={
                                <Page title="Easypos | Abonos de Factura Electronica Compra">
                                    <BuyInvoicePaymentIndex />
                                </Page>} />
                            {/* <Route path="cancel/" element={
                                <Page title="Easypos | Anular Factura">
                                    <InvoiceCancel />
                                </Page>} /> */}
                        </Route>
                        <Route path="buyInvoiceExpenses" element={
                            <Page title="Easypos | Factura de Compra Para Gastos"> <Outlet /> </Page>}>
                            <Route index element={
                                <BuyInvoiceIndex buyInvoiceType="Expense" />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Factura Electronica de Compra Para Gasto">
                                    <BuyInvoiceAdd buyInvoiceType="Expense" />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Factura Electronica de Compras para Gastos">
                                    <BuyInvoiceAdd copyData buyInvoiceType="Expense" />
                                </Page>} />
                        </Route>
                        <Route path="clients" element={
                            <Page title="Easypos | Clientes"> <Outlet /> </Page>}>
                            <Route index element={
                                <ClientIndex />
                            } />
                            <Route path="status" element={
                                <Page title="Easypos | Estado de Cuenta">
                                    <ClientStatusIndex />
                                </Page>} />
                            <Route path="payInvoices/" element={
                                <Page title="Easypos | Cancelar Facturas">
                                    <PayInvoicesIndex />
                                </Page>} />
                            <Route path="payInvoicesManually/" element={
                                <Page title="Easypos | Cancelar Facturas Recibo Manual">
                                    <PayInvoicesIndex manualRecibe />
                                </Page>} />
                            <Route path="credits/:clientId" element={
                                <Page title="Easypos | Saldos a Favor del Cliente">
                                    <ClientCreditsIndex />
                                </Page>} />
                            <Route path="import" element={
                                <Page title="Easypos | Importar Clientes">
                                    <ClientImport />
                                </Page>} />
                            {/* <Route path="movements/:id?" element={
                                <Page title="Easypos | Copiar Producto">
                                    <ProductAddEdit />
                                </Page>} /> */}
                        </Route>
                        <Route path="client-zone/:id?" element={
                            <Page title="Easypos | Modificar Zona de Clientes">
                                <ZoneAddEdit />
                            </Page>} />
                        <Route path="client-zones" element={
                            <Page title="Easypos | Zonas de Client">
                                <ZonesIndex />
                            </Page>} />
                        <Route path="credit-operator/:id?" element={
                            <Page title="Easypos | Modificar Operadores de Tarjeta">
                                <CreditOperatorAddEdit />
                            </Page>} />
                        <Route path="credit-operators" element={
                            <Page title="Easypos | Operadores de Tarjeta">
                                <CreditOperatorsIndex />
                            </Page>} />
                        <Route path="currency/:id?" element={
                            <Page title="Easypos | Modificar Moneda">
                                <CurrencyAddEdit />
                            </Page>} />
                        <Route path="currencies" element={
                            <Page title="Easypos | Monedas">
                                <CurrenciesIndex />
                            </Page>} />
                        <Route path="creditnotes" element={
                            <Page title="Easypos | Notas de Credito"> <Outlet /> </Page>}>
                            <Route index element={
                                <CreditnoteIndex />
                            } />
                            <Route path="invoice-select" element={
                                <Page title="Easypos | Seleccionar Factura para Nota de Credito">
                                    <CreditnoteInvoiceSelect />
                                </Page>} />
                            <Route path="invoice-select/price" element={
                                <Page title="Easypos | Seleccionar Factura para Nota de Credito">
                                    <CreditnoteInvoiceSelect priceNote />
                                </Page>} />
                            <Route path="add/:invoiceId" element={
                                <Page title="Easypos | Agregar Nota de Credito">
                                    <CreditnoteAdd />
                                </Page>} />
                            <Route path="addByPrice/:invoiceId" element={
                                <Page title="Easypos | Agregar Nota de Credito Por Precio">
                                    <CreditnoteAdd priceNote />
                                </Page>} />
                            <Route path="listByInvoiceId/:invoiceId" element={
                                <Page title="Easypos | Notas de Credito de Factura">
                                    <CreditnoteListByInvoiceId />
                                </Page>} />
                            <Route path="import" element={
                                <Page title="Easypos | Cargar Notas de Credito XML">
                                    <CreditnoteImport />
                                </Page>} />
                        </Route>
                        <Route path="debitnotes" element={
                            <Page title="Easypos | Notas de Debito"> <Outlet /> </Page>}>
                            <Route index element={
                                <DebitnoteIndex />
                            } />
                            <Route path="invoice-select" element={
                                <Page title="Easypos | Seleccionar Factura para Nota de Debito">
                                    <DebitnoteInvoiceSelect />
                                </Page>} />
                            <Route path="add/:invoiceId" element={
                                <Page title="Easypos | Agregar Nota de Debito">
                                    <DebitnoteAdd />
                                </Page>} />
                            <Route path="listByInvoiceId/:invoiceId" element={
                                <Page title="Easypos | Notas de Debito de Factura">
                                    <DebitnoteListByInvoiceId />
                                </Page>} />
                            <Route path="import" element={
                                <Page title="Easypos | Cargar Notas de Debito XML">
                                    <DebitnoteImport />
                                </Page>} />
                        </Route>
                        <Route path="custom-fields" element={
                            <Page title="Easypos | Informacion Personalizada">
                                <CustomFields />
                            </Page>} />
                        <Route path="custom-field/:templateId" element={
                            <Page title="Easypos | Editar Informacion Personalizada">
                                <CustomField />
                            </Page>} />
                        <Route path="dashboard" element={
                            <Page title="Easypos | Dashboard Usuario">
                                <UserDashboard />
                            </Page>} />
                        <Route path="dashboard-accounting" element={
                            <Page title="Easypos | Dashboard De Contabilidad">
                                <AccountingDashboard />
                            </Page>} />
                        <Route path="dashboard-inventory" element={
                            <Page title="Easypos | Reportes De Inventory">
                                <InventoryDashboard />
                            </Page>} />
                        <Route path="dashboard-clients" element={
                            <Page title="Easypos | Reportes De Clientes">
                                <ClientsDashboard />
                            </Page>} />
                        <Route path="dashboard-providers" element={
                            <Page title="Easypos | Reportes De Proveedores">
                                <ProvidersDashboard />
                            </Page>} />
                        <Route path="email-templates" element={
                            <Page title="Easypos | Plantillas de Correo">
                                <EmailTemplates />
                            </Page>} />
                        <Route path="email-template/:templateId" element={
                            <Page title="Easypos | Editar Plantilla de Correo">
                                <EmailTemplate />
                            </Page>} />
                        <Route path="receivedInvoices" element={
                            <Page title="Easypos | Recepcion de Docuentos"> <Outlet /> </Page>}>
                            <Route index element={
                                <ReceivedInvoiceIndex />
                            } />
                            <Route path="view/:recievedEmailId" element={
                                <Page title="Easypos | Ver Correo">
                                    <ViewReceivedInvoice />
                                </Page>} />
                        </Route>
                        <Route path="expenses" element={
                            <Page title="Easypos | Gastos"> <Outlet /> </Page>}>
                            <Route index element={
                                <ExpenseIndex />
                            } />
                            <Route path="add" element={
                                <Page title="Easypos | Crear Gastos">
                                    <ExpenseAddEdit />
                                </Page>} />
                            <Route path="edit/:id?" element={
                                <Page title="Easypos | Actualizar Gasto">
                                    <ExpenseAddEdit />
                                </Page>} />
                            <Route path="categories/" element={
                                <Page title="Easypos | Categorias de Gastos">
                                    <ExpenseCategoryIndex />
                                </Page>} />
                            <Route path="category/:id?" element={
                                <Page title="Easypos | Actualizar Categoria de Gastos">
                                    <ExpenseCategoryAddEdit />
                                </Page>} />
                            <Route path="validateEDocument/:documentXmlAttachmentId?" element={
                                <Page title="Easypos | Actualizar Categoria de Gastos">
                                    <ValidateExpenseEInvoice />
                                </Page>} />
                            <Route path="notes/:expenseId?" element={
                                <Page title="Easypos | Notas Gastos">
                                    <ExpenseNoteIndex />
                                </Page>} />
                            <Route path="notes/add/:expenseId" element={
                                <Page title="Easypos | Notas de Gasto">
                                    <ExpenseNoteAddEdit />
                                </Page>} />
                            <Route path="notes/edit/:id/:expenseId" element={
                                <Page title="Easypos | Editar Notas de Gasto">
                                    <ExpenseNoteAddEdit />
                                </Page>} />
                            <Route path="validateEDocumentNote/:documentXmlAttachmentId?" element={
                                <Page title="Easypos | Validar Nota Credito de Gastos">
                                    <ValidateExpenseENote />
                                </Page>} />
                        </Route>

                        <Route path="invoices" element={
                            <Page title="Easypos | Facturas"> <Outlet /> </Page>}>
                            <Route index element={
                                <InvoiceIndex />
                            } />
                            <Route path="holds" element={
                                <Page title="Easypos | Apartados">
                                    <InvoiceIndex onlyHolds />
                                </Page>} />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Factura">
                                    <InvoiceAdd />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Factura">
                                    <InvoiceAdd copyData />
                                </Page>} />
                            <Route path="fromQuote/:quoteId?" element={
                                <Page title="Easypos | Agregar Factura">
                                    <InvoiceAdd copyData />
                                </Page>} />
                            <Route path="payments/:invoiceId?" element={
                                <Page title="Easypos | Historial de Abonos">
                                    <InvoicePaymentIndex />
                                </Page>} />
                            <Route path="cancel/" element={
                                <Page title="Easypos | Anular Factura">
                                    <InvoiceCancel />
                                </Page>} />
                            <Route path="import/" element={
                                <Page title="Easypos | Cargar Facturas XML">
                                    <InvoiceImport />
                                </Page>} />
                        </Route>
                        <Route path="invoicetemplates" element={
                            <Page title="Easypos | Lista Plantillas de Facturas"> <Outlet /> </Page>}>
                            <Route index element={
                                <InvoiceTemplateIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Plantilla de Factura">
                                    <InvoiceTemplateAddEdit />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Plantilla de Factura">
                                    <InvoiceTemplateAddEdit copyData />
                                </Page>} />
                            <Route path="edit/:id?" element={
                                <Page title="Easypos | Editar Plantilla de Factura">
                                    <InvoiceTemplateAddEdit />
                                </Page>} />
                        </Route>

                        <Route path="interest" element={
                            <Page title="Easypos | Intereses"> <Outlet /> </Page>}>
                            <Route path="byInvoice/:documentId" element={
                                <Page title="Easypos | Intereses Generados">
                                    <DocumentInterestListByInvoiceId kind="invoice" />
                                </Page>} />
                            <Route path="bySettlement/:documentId" element={
                                <Page title="Easypos | Intereses Generados">
                                    <DocumentInterestListByInvoiceId kind="settlement" />
                                </Page>} />
                        </Route>
                        <Route path="price/:id?" element={
                            <Page title="Easypos | Editar Precios">
                                <PriceAddEdit />
                            </Page>} />
                        <Route path="api" element={
                            <Page title="Easypos | API Externa">
                                <ApiManagement />
                            </Page>} />
                        <Route path="price-management" element={
                            <Page title="Easypos | Manejo de Precios">
                                <PriceManagement />
                            </Page>} />
                        <Route path="profile/:id?" element={
                            <Page title="Easypos | Perfil de Usuario">
                                <Profile />
                            </Page>} />
                        <Route path="links" element={
                            <Page title="Easypos | Enlaces">
                                <LinksIndex />
                            </Page>} />
                        <Route path="tenant-manage" element={
                            <Page title="Easypos | Administracion de Suscripcion">
                                <TenantManage />
                            </Page>} />
                        <Route path="product/:id?" element={
                            <Page title="Easypos | Actualizar Producto">
                                <ProductAddEdit />
                            </Page>} />
                        <Route path="products" element={
                            <Page title="Easypos | Productos"> <Outlet /> </Page>}>
                            <Route index element={
                                <ProductIndex />
                            } />
                            <Route path="inventory-management" element={
                                <Page title="Easypos | Administración de Inventarios">
                                    <InventoryManagement />
                                </Page>} />
                            <Route path="inventory-management/verify-cabys" element={
                                <Page title="Easypos | Verificar CAByS de Productos">
                                    <CabysAudit target="product" />
                                </Page>} />
                            <Route path="inventory-management/verify-cabys-categories" element={
                                <Page title="Easypos | Verificar CAByS de Categorías">
                                    <CabysAudit target="category" />
                                </Page>} />
                            <Route path="generateBarcode" element={
                                <Page title="Easypos | Generar Codigos de Barra">
                                    <ProductGenerateBarcode />
                                </Page>} />
                            <Route path="import" element={
                                <Page title="Easypos | Importar Productos">
                                    <ProductImport />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Producto">
                                    <ProductAddEdit copyData />
                                </Page>} />
                            <Route path="historical-cost/:id?" element={
                                <Page title="Easypos | Historial de Costo">
                                    <ProductCostLogIndex />
                                </Page>} />
                            <Route path="movements/:id?" element={
                                <Page title="Easypos | Movimientos de Producto">
                                    <ProductlogIndex />
                                </Page>} />
                        </Route>
                        <Route path="provider/:id?" element={
                            <Page title="Easypos | Actualizar Provedor">
                                <ProviderAddEdit />
                            </Page>} />
                        <Route path="providers" element={
                            <Page title="Easypos | Provedores"> <Outlet /> </Page>}>
                            <Route index element={
                                <ProviderIndex />
                            } />
                            <Route path="status" element={
                                <Page title="Easypos | Estado de Cuenta Provedor">
                                    <ProviderStatusIndex />
                                </Page>} />
                            <Route path="payInvoices/" element={
                                <Page title="Easypos | Cancelar Facturas de Provedores">
                                    <PayProviderInvoicesIndex />
                                </Page>} />
                            <Route path="import" element={
                                <Page title="Easypos | Importar Proveedores">
                                    <ProviderImport />
                                </Page>} />

                        </Route>
                        <Route path="provider-recibes" element={
                            <Page title="Easypos | Recibos de Provedor"> <Outlet /> </Page>}>
                            <Route index element={
                                <ProviderRecibeIndex />
                            } />
                            <Route path="repair" element={
                                <Page title="Easypos | Reparar Recibos de Proveedor">
                                    <ProviderRecibeRepairIndex />
                                </Page>} />
                            <Route path="view/:providerRecibeId" element={
                                <Page title="Easypos | Ver Recibo de Provedor">
                                    <ProviderRecibeView />
                                </Page>} />
                        </Route>


                        <Route path="provider-invoices" element={
                            <Page title="Easypos | Cuentas por Cobrar"> <Outlet /> </Page>}>
                            <Route index element={
                                <ProviderInvoiceIndex />
                            } />
                            <Route path="notes/add/:providerInvoiceId" element={
                                <Page title="Easypos | Notas de Factura Provedor">
                                    <ProviderNoteAddEdit />
                                </Page>} />
                            <Route path="notes/edit/:id/:providerInvoiceId" element={
                                <Page title="Easypos | Editar Notas de Factura de Provedor">
                                    <ProviderNoteAddEdit />
                                </Page>} />
                            <Route path="notes/:id?" element={
                                <Page title="Easypos | Notas de Factura Provedor">
                                    <ProviderNoteIndex />
                                </Page>} />
                            <Route path="payments/add/:providerInvoiceId" element={
                                <Page title="Easypos | Agregar Abono de Factura Provedor">
                                    <ProviderInvoicePaymentAddEdit />
                                </Page>} />
                            <Route path="payments/edit/:id/:providerInvoiceId" element={
                                <Page title="Easypos | Editar Abono de Factura de Provedor">
                                    <ProviderInvoicePaymentAddEdit />
                                </Page>} />
                            <Route path="payments/:id?" element={
                                <Page title="Easypos | Abonos de Factura Provedor">
                                    <ProviderInvoicePaymentIndex />
                                </Page>} />
                            <Route path="invoice/:id?" element={
                                <Page title="Easypos | Actualizar Factura Provedor">
                                    <ProviderInvoiceAddEdit />
                                </Page>} />
                            <Route path="addWithInventory/:documentXmlAttachmentId?" element={
                                <Page title="Easypos | Agregar Factura Provedor e inventario">
                                    <ProviderInvoiceAddWithInventory />
                                </Page>} />
                            <Route path="view/:id?" element={
                                <Page title="Easypos | Actualizar Factura Provedor">
                                    <ProviderInvoiceAddEdit />
                                </Page>} />
                            <Route path="categories/" element={
                                <Page title="Easypos | Categorias de Compras">
                                    <ProviderInvoiceCategoryIndex />
                                </Page>} />
                            <Route path="category/:id?" element={
                                <Page title="Easypos | Actualizar Categorias de Compras">
                                    <ProviderInvoiceCategoryAddEdit />
                                </Page>} />
                            <Route path="validateEDocument/:documentXmlAttachmentId?" element={
                                <Page title="Easypos | Aceptar Factura Electronica">
                                    <ValidateEInvoice />
                                </Page>} />
                            <Route path="notes/validateENote/:documentXmlAttachmentId?" element={
                                <Page title="Easypos | Validar Nota Credito Electronica">
                                    <ValidateENote />
                                </Page>} />
                        </Route>
                        <Route path="providerorders" element={
                            <Page title="Easypos | Ordenes de Compra"> <Outlet /> </Page>}>
                            <Route index element={
                                <ProviderOrderIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Orden de Compra">
                                    <ProviderOrderAddEdit />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Orden de Compra">
                                    <ProviderOrderAddEdit copyData />
                                </Page>} />
                        </Route>
                        <Route path="quotes" element={
                            <Page title="Easypos | Cotizaciones"> <Outlet /> </Page>}>
                            <Route index element={
                                <QuoteIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Cotizacion">
                                    <QuoteAddEdit />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Cotizacion">
                                    <QuoteAddEdit copyData />
                                </Page>} />
                            <Route path="edit/:id?" element={
                                <Page title="Easypos | Editar Cotizacion">
                                    <QuoteAddEdit />
                                </Page>} />
                        </Route>
                        <Route path="recibes" element={
                            <Page title="Easypos | Recibos"> <Outlet /> </Page>}>
                            <Route index element={
                                <RecibeIndex />
                            } />
                            <Route path="add" element={
                                <Page title="Easypos | Agregar Recibo">
                                    <RecibeAddEdit />
                                </Page>} />
                        </Route>
                        <Route path="reports" element={
                            <Page title="Easypos | Reports"> <Outlet /> </Page>}>
                            <Route path="sellByMonth" element={
                                <Page title="Easypos | Reporte Ventas">
                                    <SellByMonthReport />
                                </Page>} />
                            <Route path="sellByYear" element={
                                <Page title="Easypos | Reporte Ventas">
                                    <SellByYearReport />
                                </Page>} />
                            <Route path="buyByMonth" element={
                                <Page title="Easypos | Reporte Compras">
                                    <BuyByMonthReport />
                                </Page>} />
                            <Route path="buyByYear" element={
                                <Page title="Easypos | Reporte Compras">
                                    <BuyByYearReport />
                                </Page>} />
                            <Route path="expensesByMonth" element={
                                <Page title="Easypos | Reporte Gasto">
                                    <ExpenseByMonthReport />
                                </Page>} />
                            <Route path="expensesByYear" element={
                                <Page title="Easypos | Reporte Gasto">
                                    <ExpenseByYearReport />
                                </Page>} />
                            <Route path="sales-by-products" element={
                                <Page title="Easypos | Reporte de ventas por producto">
                                    <SalesByProductReport />
                                </Page>} />
                            <Route path="sales-by-clients" element={
                                <Page title="Easypos | Reporte de Historial de Ventas por Cliente">
                                    <SalesByClientReport />
                                </Page>} />
                            <Route path="products-by-category" element={
                                <Page title="Easypos | Reporte por Categoria">
                                    <ProductsByCategoryReport />
                                </Page>} />
                            <Route path="searchByReference" element={
                                <Page title="Easypos | Buscar Documentos por Referencia">
                                    <SearchByReferenceReport />
                                </Page>} />
                            <Route path="edocuments" element={
                                <Page title="Easypos | Reporte de Documentos Electronicos">
                                    <EDocumentsReport />
                                </Page>} />
                            <Route path="clientSettlements" element={
                                <Page title="Easypos | Reporte Liquidaciones">
                                    <ClientSettlementsReport />
                                </Page>} />
                        </Route>
                        <Route path="saleman/:id?" element={
                            <Page title="Easypos | Vendedor">
                                <SalesmanAddEdit />
                            </Page>} />
                        <Route path="salemen" element={
                            <Page title="Easypos | Vendedores">
                                <SalesmanIndex />
                            </Page>} />
                        <Route path="settlements" element={
                            <Page title="Easypos | Liquidaciones"> <Outlet /> </Page>}>
                            <Route index element={
                                <SettlementIndex />
                            } />
                            <Route path="add/" element={
                                <Page title="Easypos | Agregar Factura">
                                    <SettlementAdd />
                                </Page>} />
                            <Route path="copy/:id?" element={
                                <Page title="Easypos | Copiar Factura">
                                    <SettlementAdd copyData />
                                </Page>} />
                            <Route path="payments/:settlementId?" element={
                                <Page title="Easypos | Historial de Abonos">
                                    <SettlementPaymentIndex />
                                </Page>} />
                        </Route>
                    </Route>
                </Route>

                <Route element={<ExcelLayout />}>
                    <Route path="/user" element={<PrivateRoute />} >
                        <Route path="reports" element={
                            <Page title="Easypos | Reports"> <Outlet /> </Page>}>
                            <Route path="excel/buyByMonth/:providerId/:startDate/:endDate/:autoPrint?" element={
                                <Page title="Easypos | Reporte Compras">
                                    <BuyByPeriodReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/expenseByMonth/:startDate/:endDate/:autoPrint?" element={
                                <Page title="Easypos | Reporte Gastos">
                                    <ExpenseByPeriodReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/sales-by-clients/:clientId/:salemanId/:startDate/:endDate/:groupBy/:autoPrint?" element={
                                <Page title="Easypos | Reporte de Ventas por Cliente">
                                    <SalesByClientReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/sellByPeriod/:clientId/:zoneId/:startDate/:endDate/:detallarIva?/:autoPrint?/:includeSettlements?" element={
                                <Page title="Easypos | Reporte Gastos">
                                    <SellByPeriodReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/clientSettlements/:clientId/:zoneId/:startDate/:endDate/:excludeAnuladas?/:autoPrint?" element={
                                <Page title="Easypos | Reporte Liquidaciones">
                                    <ClientSettlementsReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/products-by-category/:categoryId/:properties/:includeInactive?" element={
                                <Page title="Easypos | Reporte por Categoria">
                                    <ProductsByCategoryReportPrint excelExport={true} />
                                </Page>} />
                            <Route path="excel/edocuments/:kind?" element={
                                <Page title="Easypos | Reporte de Documentos Electronicos">
                                    <EDocumentsReportExcel />
                                </Page>} />
                            <Route path="product-export" element={
                                <Page title="Easypos | Reporte Invetario">
                                    <InventoryReportExcel />
                                </Page>} />
                        </Route>
                    </Route>
                </Route>
                <Route element={<PrintLayout />}>
                    <Route path="/user" element={<PrivateRoute />} >
                        <Route path="clients" >
                            <Route path="printStatus/:queryProps/:autoPrint?" element={
                                <Page title="Easypos | Estado de Cuenta">
                                    <ClientPrintStatus />
                                </Page>} />
                        </Route>
                        <Route path="invoices" >
                            <Route path="payments/view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Abono Factura">
                                    <InvoicePaymentPrint />
                                </Page>} />
                            <Route path="payments/print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Abono Factura">
                                    <InvoicePaymentPrint />
                                </Page>} />
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Factura">
                                    <InvoicePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Factura">
                                    <InvoicePrint />
                                </Page>} />
                            <Route path="shipping-guide/:id?/:autoPrint?" element={
                                <Page title="Easypos | Guia de Envio">
                                    <InvoiceShippingGuide />
                                </Page>} />
                        </Route>
                        <Route path="buyInvoices" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Factura de Compra">
                                    <BuyInvoicePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Factura de Compra">
                                    <BuyInvoicePrint />
                                </Page>} />
                        </Route>
                        <Route path="creditnotes" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Nota de Credito">
                                    <CreditnotePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Nota de Credito">
                                    <CreditnotePrint />
                                </Page>} />
                        </Route>
                        <Route path="debitnotes" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Nota de Debito">
                                    <DebitnotePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Nota de Debito">
                                    <DebitnotePrint />
                                </Page>} />
                        </Route>
                        <Route path="providers" >
                            <Route path="printStatus/:queryProps/:autoPrint?" element={
                                <Page title="Easypos | Estado de Cuenta Provedor">
                                    <ProviderPrintStatus />
                                </Page>} />
                        </Route>
                        <Route path="providerorders" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Orden de Compra">
                                    <ProviderOrderPrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Orden de Compra ">
                                    <ProviderOrderPrint />
                                </Page>} />
                        </Route>
                        <Route path="quotes" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Cotizacion">
                                    <QuotePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Cotizacion">
                                    <QuotePrint />
                                </Page>} />
                        </Route>
                        <Route path="settlements" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Liquidacion">
                                    <SettlementPrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Liquidacion">
                                    <SettlementPrint />
                                </Page>} />
                        </Route>
                        <Route path="reports" element={
                            <Page title="Easypos | Reports"> <Outlet /> </Page>}>
                            <Route path="print/buyByMonth/:providerId/:startDate/:endDate/:autoPrint?" element={
                                <Page title="Easypos | Reporte Compras">
                                    <BuyByPeriodReportPrint />
                                </Page>} />
                            <Route path="print/expenseByMonth/:startDate/:endDate/:autoPrint?" element={
                                <Page title="Easypos | Reporte Gastos">
                                    <ExpenseByPeriodReportPrint />
                                </Page>} />
                            <Route path="print/sales-by-clients/:clientId/:salemanId/:startDate/:endDate/:groupBy/:autoPrint?" element={
                                <Page title="Easypos | Reporte de Ventas por Cliente">
                                    <SalesByClientReportPrint />
                                </Page>} />
                            <Route path="print/products-by-category/:categoryId/:properties/:includeInactive?/:autoPrint?" element={
                                <Page title="Easypos | Reporte por Categoria">
                                    <ProductsByCategoryReportPrint />
                                </Page>} />
                            <Route path="print/sellByPeriod/:clientId/:zoneId/:startDate/:endDate/:autoPrint?/:includeSettlements?" element={
                                <Page title="Easypos | Reporte Gastos">
                                    <SellByPeriodReportPrint />
                                </Page>} />
                            <Route path="print/clientSettlements/:clientId/:zoneId/:startDate/:endDate/:excludeAnuladas?/:autoPrint?" element={
                                <Page title="Easypos | Reporte Liquidaciones">
                                    <ClientSettlementsReportPrint />
                                </Page>} />
                            <Route path="inventory" element={
                                <Page title="Easypos | Reporte Inventario">
                                    <InventoryReportPrint />
                                </Page>} />
                            <Route path="list-price/:priceId/:onlyOnStock?" element={
                                <Page title="Easypos | Lista de Precio">
                                    <ListPriceReportPrint />
                                </Page>} />
                        </Route>
                        <Route path="recibes" >
                            <Route path="view/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Ver Recibo">
                                    <RecibePrint />
                                </Page>} />
                            <Route path="print/:id?/:copies?/:autoPrint?" element={
                                <Page title="Easypos | Imprimir Recibo">
                                    <RecibePrint />
                                </Page>} />
                        </Route>
                    </Route>
                </Route>
            </Routes>
    );
};

const AppRouter = () => {
    return (
        <Router>
            <PageTracker />
            <AppRoutes />
            {/* <Footer /> */}
        </Router >
    );
};

export default AppRouter;